export enum SubAppName {
	DeviceSettings = 'settings',
	SmartPrivacy = 'privacy',
	SmartPerformance = 'performance',
	SmartLock = 'lock',
	Support = 'support',
	ModernPreload= 'modern-preload'
}
